(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('hyperapp')) :
	typeof define === 'function' && define.amd ? define(['exports', 'hyperapp'], factory) :
	(factory((global.html = {}),global.hyperapp));
}(this, (function (exports,hyperapp) { 'use strict';

function vnode(name) {
  return function (props, children) {
    return typeof props === "object" && !Array.isArray(props)
      ? hyperapp.h(name, props, children)
      : hyperapp.h(name, {}, props)
  }
}


function a(props, children) {
  return vnode("a")(props, children)
}

function abbr(props, children) {
  return vnode("abbr")(props, children)
}

function address(props, children) {
  return vnode("address")(props, children)
}

function area(props, children) {
  return vnode("area")(props, children)
}

function article(props, children) {
  return vnode("article")(props, children)
}

function aside(props, children) {
  return vnode("aside")(props, children)
}

function audio(props, children) {
  return vnode("audio")(props, children)
}

function b(props, children) {
  return vnode("b")(props, children)
}

function bdi(props, children) {
  return vnode("bdi")(props, children)
}

function bdo(props, children) {
  return vnode("bdo")(props, children)
}

function blockquote(props, children) {
  return vnode("blockquote")(props, children)
}

function br(props, children) {
  return vnode("br")(props, children)
}

function button(props, children) {
  return vnode("button")(props, children)
}

function canvas(props, children) {
  return vnode("canvas")(props, children)
}

function caption(props, children) {
  return vnode("caption")(props, children)
}

function cite(props, children) {
  return vnode("cite")(props, children)
}

function code(props, children) {
  return vnode("code")(props, children)
}

function col(props, children) {
  return vnode("col")(props, children)
}

function colgroup(props, children) {
  return vnode("colgroup")(props, children)
}

function data(props, children) {
  return vnode("data")(props, children)
}

function datalist(props, children) {
  return vnode("datalist")(props, children)
}

function dd(props, children) {
  return vnode("dd")(props, children)
}

function del(props, children) {
  return vnode("del")(props, children)
}

function details(props, children) {
  return vnode("details")(props, children)
}

function dfn(props, children) {
  return vnode("dfn")(props, children)
}

function dialog(props, children) {
  return vnode("dialog")(props, children)
}

function div(props, children) {
  return vnode("div")(props, children)
}

function dl(props, children) {
  return vnode("dl")(props, children)
}

function dt(props, children) {
  return vnode("dt")(props, children)
}

function em(props, children) {
  return vnode("em")(props, children)
}

function embed(props, children) {
  return vnode("embed")(props, children)
}

function fieldset(props, children) {
  return vnode("fieldset")(props, children)
}

function figcaption(props, children) {
  return vnode("figcaption")(props, children)
}

function figure(props, children) {
  return vnode("figure")(props, children)
}

function footer(props, children) {
  return vnode("footer")(props, children)
}

function form(props, children) {
  return vnode("form")(props, children)
}

function h1(props, children) {
  return vnode("h1")(props, children)
}

function h2(props, children) {
  return vnode("h2")(props, children)
}

function h3(props, children) {
  return vnode("h3")(props, children)
}

function h4(props, children) {
  return vnode("h4")(props, children)
}

function h5(props, children) {
  return vnode("h5")(props, children)
}

function h6(props, children) {
  return vnode("h6")(props, children)
}

function header(props, children) {
  return vnode("header")(props, children)
}

function hr(props, children) {
  return vnode("hr")(props, children)
}

function i(props, children) {
  return vnode("i")(props, children)
}

function img(props, children) {
  return vnode("img")(props, children)
}

function input(props, children) {
  return vnode("input")(props, children)
}

function ins(props, children) {
  return vnode("ins")(props, children)
}

function kbd(props, children) {
  return vnode("kbd")(props, children)
}

function label(props, children) {
  return vnode("label")(props, children)
}

function legend(props, children) {
  return vnode("legend")(props, children)
}

function li(props, children) {
  return vnode("li")(props, children)
}

function main(props, children) {
  return vnode("main")(props, children)
}

function map(props, children) {
  return vnode("map")(props, children)
}

function mark(props, children) {
  return vnode("mark")(props, children)
}

function menu(props, children) {
  return vnode("menu")(props, children)
}

function menuitem(props, children) {
  return vnode("menuitem")(props, children)
}

function meter(props, children) {
  return vnode("meter")(props, children)
}

function nav(props, children) {
  return vnode("nav")(props, children)
}

function object(props, children) {
  return vnode("object")(props, children)
}

function ol(props, children) {
  return vnode("ol")(props, children)
}

function optgroup(props, children) {
  return vnode("optgroup")(props, children)
}

function option(props, children) {
  return vnode("option")(props, children)
}

function output(props, children) {
  return vnode("output")(props, children)
}

function p(props, children) {
  return vnode("p")(props, children)
}

function param(props, children) {
  return vnode("param")(props, children)
}

function pre(props, children) {
  return vnode("pre")(props, children)
}

function progress(props, children) {
  return vnode("progress")(props, children)
}

function q(props, children) {
  return vnode("q")(props, children)
}

function rp(props, children) {
  return vnode("rp")(props, children)
}

function rt(props, children) {
  return vnode("rt")(props, children)
}

function rtc(props, children) {
  return vnode("rtc")(props, children)
}

function ruby(props, children) {
  return vnode("ruby")(props, children)
}

function s(props, children) {
  return vnode("s")(props, children)
}

function samp(props, children) {
  return vnode("samp")(props, children)
}

function section(props, children) {
  return vnode("section")(props, children)
}

function select(props, children) {
  return vnode("select")(props, children)
}

function small(props, children) {
  return vnode("small")(props, children)
}

function source(props, children) {
  return vnode("source")(props, children)
}

function span(props, children) {
  return vnode("span")(props, children)
}

function strong(props, children) {
  return vnode("strong")(props, children)
}

function sub(props, children) {
  return vnode("sub")(props, children)
}

function summary(props, children) {
  return vnode("summary")(props, children)
}

function sup(props, children) {
  return vnode("sup")(props, children)
}

function svg(props, children) {
  return vnode("svg")(props, children)
}

function table(props, children) {
  return vnode("table")(props, children)
}

function tbody(props, children) {
  return vnode("tbody")(props, children)
}

function td(props, children) {
  return vnode("td")(props, children)
}

function textarea(props, children) {
  return vnode("textarea")(props, children)
}

function tfoot(props, children) {
  return vnode("tfoot")(props, children)
}

function th(props, children) {
  return vnode("th")(props, children)
}

function thead(props, children) {
  return vnode("thead")(props, children)
}

function time(props, children) {
  return vnode("time")(props, children)
}

function tr(props, children) {
  return vnode("tr")(props, children)
}

function track(props, children) {
  return vnode("track")(props, children)
}

function u(props, children) {
  return vnode("u")(props, children)
}

function ul(props, children) {
  return vnode("ul")(props, children)
}

function video(props, children) {
  return vnode("video")(props, children)
}

function vvar(props, children) {
  return vnode("vvar")(props, children)
}

function wbr(props, children) {
  return vnode("wbr")(props, children)
}

exports.a = a;
exports.abbr = abbr;
exports.address = address;
exports.area = area;
exports.article = article;
exports.aside = aside;
exports.audio = audio;
exports.b = b;
exports.bdi = bdi;
exports.bdo = bdo;
exports.blockquote = blockquote;
exports.br = br;
exports.button = button;
exports.canvas = canvas;
exports.caption = caption;
exports.cite = cite;
exports.code = code;
exports.col = col;
exports.colgroup = colgroup;
exports.data = data;
exports.datalist = datalist;
exports.dd = dd;
exports.del = del;
exports.details = details;
exports.dfn = dfn;
exports.dialog = dialog;
exports.div = div;
exports.dl = dl;
exports.dt = dt;
exports.em = em;
exports.embed = embed;
exports.fieldset = fieldset;
exports.figcaption = figcaption;
exports.figure = figure;
exports.footer = footer;
exports.form = form;
exports.h1 = h1;
exports.h2 = h2;
exports.h3 = h3;
exports.h4 = h4;
exports.h5 = h5;
exports.h6 = h6;
exports.header = header;
exports.hr = hr;
exports.i = i;
exports.img = img;
exports.input = input;
exports.ins = ins;
exports.kbd = kbd;
exports.label = label;
exports.legend = legend;
exports.li = li;
exports.main = main;
exports.map = map;
exports.mark = mark;
exports.menu = menu;
exports.menuitem = menuitem;
exports.meter = meter;
exports.nav = nav;
exports.object = object;
exports.ol = ol;
exports.optgroup = optgroup;
exports.option = option;
exports.output = output;
exports.p = p;
exports.param = param;
exports.pre = pre;
exports.progress = progress;
exports.q = q;
exports.rp = rp;
exports.rt = rt;
exports.rtc = rtc;
exports.ruby = ruby;
exports.s = s;
exports.samp = samp;
exports.section = section;
exports.select = select;
exports.small = small;
exports.source = source;
exports.span = span;
exports.strong = strong;
exports.sub = sub;
exports.summary = summary;
exports.sup = sup;
exports.svg = svg;
exports.table = table;
exports.tbody = tbody;
exports.td = td;
exports.textarea = textarea;
exports.tfoot = tfoot;
exports.th = th;
exports.thead = thead;
exports.time = time;
exports.tr = tr;
exports.track = track;
exports.u = u;
exports.ul = ul;
exports.video = video;
exports.vvar = vvar;
exports.wbr = wbr;

Object.defineProperty(exports, '__esModule', { value: true });

})));
